import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { RotateLoader} from 'react-spinners';
import * as DOMPurify from 'dompurify';
import { myUtilities } from './';

class LoadingUtility extends React.Component {
    render(){
      return (
        <Container className="payment-check-container payment-loader">
          <Row className="payment-check-marginTop"><Col></Col></Row>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <Row>
            <Col className="payment-check-element check-pay-trifecta">
            <RotateLoader
              size={15}
              sizeUnit={"px"}
              color={'#000000'}
              loading={true}
            />
            </Col>
            	<div className="loading-gif-trifecta"></div>
          </Row>
          <Row className="payment-check-space"><Col></Col></Row>
          <Row>
            <Col className="payment-check-element">
            {myUtilities.accountSpecificLanguage(
               this.props.id, 
              "Please wait getting " + this.props.name + " details"
              )}
            </Col>
          </Row>
          </Container>
      );
    }
  }

  export default LoadingUtility;

